export const PLACEHOLDER_SELECT_RANKING = '-';

export const ERROR_TEXT_RANKING = 'Please rank all options';

export const DESCRIPTION_LABEL = 'Drag and Drop to rank options';
